import { AlertTriangle, PlugZap } from 'lucide-react';
import type { MarketingError } from '../api/errors';
import { EmptyState } from '@/shared/components/empty-state';
import { Button } from '@/shared/ui/button';
import { Card } from '@/shared/ui/card';
import { Skeleton } from '@/shared/ui/skeleton';

export function ChannelLoading({ label }: { label: string }) {
  return (
    <div aria-busy="true" aria-live="polite" className="space-y-3">
      <span className="sr-only">{label}</span>
      <Skeleton className="h-28 rounded-2xl" />
      <Skeleton className="h-64 rounded-2xl" />
    </div>
  );
}

/**
 * Falha ao falar com a API. Rota ausente no servidor (módulo ainda não
 * ligado) ganha ícone e texto próprios; o resto mostra a mensagem que a API
 * devolveu e um botão real de tentar de novo.
 */
export function ChannelErrorState({
  title = 'Não foi possível carregar',
  error,
  description,
  onRetry,
}: {
  title?: string;
  error?: MarketingError | null;
  description?: string;
  onRetry?: () => void;
}) {
  const unavailable = error?.kind === 'unavailable';
  const text =
    description ??
    (unavailable
      ? `${error.message} Quando o fixe-api subir com o módulo ligado, esta tela passa a carregar sozinha.`
      : error?.message ?? 'O servidor não respondeu. Tente de novo em instantes.');
  return (
    <Card>
      <EmptyState
        icon={unavailable ? PlugZap : AlertTriangle}
        title={unavailable ? 'Módulo ainda não ligado no servidor' : title}
        description={text}
        action={
          onRetry ? (
            <Button type="button" variant="secondary" onClick={onRetry}>
              Tentar de novo
            </Button>
          ) : undefined
        }
      />
    </Card>
  );
}
